export interface HeadLoftHand {
  headLoftHandId: number;
  headModelId: number;
  loftId: number;
  handId: number;
}

export interface LoftsAndHandAndHeadModel {
  loftHandHeadId: number;
  loftId: number;
  name: string;
  sortId: number;
  isActive: boolean;
  headLoftHand: HeadLoftHand[];
}
export interface LoftHandHeadModel {
  headLoftHandId: number;
  loftId: number;
  name: string;
  sortId: number;
  isActive: boolean;
  headModelId: number;
  handId: number;
}

export const mappingLoftHandHeadModel = (lofts: LoftsAndHandAndHeadModel[]) => {
  var models = [] as LoftHandHeadModel[];
  lofts.forEach((loft) => {
    loft.headLoftHand.forEach((head) => {
      models.push({ headLoftHandId: head.headLoftHandId, loftId: loft.loftId, name: loft.name, sortId: loft.sortId, isActive: loft.isActive, headModelId: head.headModelId, handId: head.handId });
    });
  });
  return models;
};
